import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { MatIcon } from "@angular/material/icon";
import { MatMenu, MatMenuItem, MatMenuTrigger } from "@angular/material/menu";
import { MatDivider } from "@angular/material/divider";
import { AuthService } from "../../../services/auth.service";
import { Router } from "@angular/router";
import { TranslatePipe } from "@tolgee/ngx";
import { AvatarComponent } from "../../core/avatar/avatar.component";
import { UserService } from "../../../services/user.service";

@Component({
	selector: "app-user-badge",
	imports: [MatIcon, MatMenu, MatMenuTrigger, MatMenuItem, MatDivider, TranslatePipe, AvatarComponent],
	templateUrl: "./user-badge.component.html",
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: "./user-badge.component.scss",
})
export class UserBadgeComponent {
	authService = inject(AuthService);
	userService = inject(UserService);
	private router = inject(Router);

	navigateToAbout(): void {
		this.router.navigate(["misc/about"]);
	}

	navigateToPreferences(): void {
		this.router.navigate(["settings-user"]);
	}
}
